'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSwitchClassName;

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSwitchClassName(_ref) {
  var scales = _ref.scales;

  var defaultAppearance = _themer.Themer.createSwitchAppearance({
    base: {
      transition: 'all 120ms ease-in-out',
      cursor: 'pointer',
      color: 'white',
      backgroundColor: scales.neutral.N5A,
      borderRadius: 9999
    },
    disabled: {
      opacity: 0.5,
      backgroundImage: 'none'
    },
    hover: {
      backgroundColor: scales.neutral.N5A
    },
    active: {
      backgroundColor: scales.neutral.N6A
    },
    focus: {
      boxShadow: '0 0 0 3px ' + scales.primary.P6A
    },
    checked: {
      backgroundColor: scales.primary.P8,
      color: 'white'
    },
    checkedHover: {
      backgroundColor: scales.primary.P8,
      color: 'white'
    },
    checkedActive: {
      backgroundColor: scales.primary.P9,
      color: 'white'
    },
    checkedDisabled: {}
  });

  /**
   * Get the className of a `Switch`.
   * @param {string} appearance
   * @return {Object} the appearance object.
   */
  var getSwitchAppearance = function getSwitchAppearance() {
    return defaultAppearance;
  };

  /**
   * Get the className of a `Switch`.
   * @param {string} appearance
   * @return {string} the appearance class name.
   */
  return (0, _memoizeClassName2.default)(getSwitchAppearance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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